import { EnvelopeSimpleIcon } from '@phosphor-icons/react';
import { T } from 'gt-react';
import { useNavigate } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { useCan } from '@/hooks/useCan';
import paths from '@/paths';

interface InboundEmailsMenuItemProps {
  /** Gently staff in admin view mode — always allowed. */
  admin: boolean;
  /** Restricted (external) users never see internal tooling. */
  restricted: boolean;
}

/**
 * User-menu entry for the Inbound Emails page. Mirrors the route's
 * `adminOrPermission` gate: Gently staff or `Read InboundEmail`. Renders
 * nothing otherwise.
 */
export function InboundEmailsMenuItem({
  admin,
  restricted,
}: InboundEmailsMenuItemProps) {
  const navigate = useNavigate();
  const [canReadInboundEmails] = useCan(Action.Read, Subject.InboundEmail);
  const allowed = !restricted && (admin || canReadInboundEmails);
  if (!allowed) return null;

  return (
    <DropdownMenuItem
      onClick={() => navigate({ to: paths.authenticated.inboundEmails })}
    >
      <EnvelopeSimpleIcon />
      <T>Inbound Emails</T>
    </DropdownMenuItem>
  );
}
